function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, Image, Modal, Alert } from "antd";
import Common from "../includes/Common";
import { SendCheckFill } from "react-bootstrap-icons";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var confirm = Modal.confirm;
var TextArea = Input.TextArea;
var SendSmsToList = function SendSmsToList(_ref) {
  var handler = _ref.handler,
    session = _ref.session;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    subjects = _useState2[0],
    setSubjects = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isFormProcessing = _useState8[0],
    setIsFormProcessing = _useState8[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var onFinish = function onFinish(values) {
    confirm({
      title: /*#__PURE__*/_jsx("b", {
        children: "Confirmez-vous ?"
      }),
      content: /*#__PURE__*/_jsxs("p", {
        children: ["L'envoie du message \"", values.message, "\" aux ", session.attendants.length, " participants de la session - ", session.label]
      }),
      onOk: function onOk() {
        sendToSession(values);
      }
    });
  };
  var sendToSession = function sendToSession(values) {
    var fData = new FormData();
    fData.append("session_id", session.id);
    fData.append("message", values.message);
    fData.append("user_id", Common.currentUser.id);
    setIsFormProcessing(true);
    axios.post(Common.baseApiUrl + "sendtosession", fData).then(function (response) {
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {}, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs("p", {
      children: ["Envoyer un message aux ", session.attendants.length, " participants \xE0 la session ", session.label]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        textAlign: "center",
        minHeight: "90px"
      },
      children: /*#__PURE__*/_jsx(Image, {
        preview: false,
        src: "drawables/send-sms.png",
        width: "170px"
      })
    }), /*#__PURE__*/_jsxs(Form, {
      onFinish: onFinish,
      layout: "vertical",
      form: form,
      children: [(errorMessage.length > 0 || successMessage.length > 0) && /*#__PURE__*/_jsxs(Form.Item, {
        children: [successMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "message",
        label: "Le message",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(TextArea, {
          autoSize: true,
          maxLength: 160,
          showCount: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsxs("b", {
            children: [/*#__PURE__*/_jsx(SendCheckFill, {
              size: 21
            }), " ENVOYER"]
          })
        })
      })]
    })]
  });
};
export default SendSmsToList;